import { FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { useParams } from "react-router";

import { BreedGroupBreedApi, BreedGroupBreedDto, BreedGroupBreedSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { Link } from "react-router-dom";
import { CustomDataTable, ExportButton } from "../../../../components";

export interface IBreedGroupBreedPageProps {}

export const BreedGroupBreedPage: React.FunctionComponent<IBreedGroupBreedPageProps> = (props) => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTl();
  const api = useApiService(BreedGroupBreedApi);
  const { currentLanguage } = useGlobalData();
  const [sobjState, setsobjState] = React.useState<any>();
  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [15, 25, 50],
    pageSize: 15,
    sortKeys: { name: "ASC" },
  });

  const { totalCount } = tableState;

  const searchFunction = React.useCallback(
    (sObj?: BreedGroupBreedSearch) => {
      setsobjState(
        BreedGroupBreedSearch.fromJS({ ...sObj, languageCode: currentLanguage.languageCode, breedGroupId: +id })
      );
      return api.baseSearch(
        BreedGroupBreedSearch.fromJS({ ...sObj, languageCode: currentLanguage.languageCode, breedGroupId: +id })
      );
    },
    [api, currentLanguage.languageCode, id]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (row: BreedGroupBreedDto) => (
          <Link target="_blank" to={`${ERoutes.breeds}/${row.breedId}/detail/view`}>
            {row.name}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Country),
        fieldName: "country",
        render: (row: BreedGroupBreedDto) => (
          <Link target="_blank" to={`${ERoutes.country}/${row.countryId}/detail/view`}>
            {row.country}
          </Link>
        ),
      },
    ],
    [t]
  );
  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return (
    <FieldSet
      title={
        totalCount > 1
          ? t(ETLCodes.TableResults_Plural, { count: totalCount })
          : t(ETLCodes.TableResults, { count: totalCount })
      }
      rightElement={<ExportButton exportFunction={(sobj) => api.exportXlsFile(sobj)} sObj={sobjState} />}
    >
      <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
